import { render, staticRenderFns } from "./recharge-list.vue?vue&type=template&id=24f88b72&scoped=true&"
import script from "./recharge-list.vue?vue&type=script&lang=js&"
export * from "./recharge-list.vue?vue&type=script&lang=js&"
import style0 from "./recharge-list.vue?vue&type=style&index=0&id=24f88b72&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f88b72",
  null
  
)

export default component.exports